
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/drafts",
      function () {
        return require("private-next-pages/drafts.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/drafts"])
      });
    }
  